import { render, staticRenderFns } from "./CustomSimpleTable.vue?vue&type=template&id=d921bea0&scoped=true"
import script from "./CustomSimpleTable.vue?vue&type=script&lang=js"
export * from "./CustomSimpleTable.vue?vue&type=script&lang=js"
import style0 from "./CustomSimpleTable.vue?vue&type=style&index=0&id=d921bea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d921bea0",
  null
  
)

export default component.exports